import React from 'react';
import { Select } from 'antd';
import services from '../../../services';
import $ from 'jquery';

const { Option } = Select;
var thisSelect;
var optionAllSelos = [];
var dateValueItem;
var optionsSelos = [];
var optionsSelos2 = [];
var entidadeSelected = null;
function myFunction(selection) {
    optionsSelos = [];
    optionsSelos2 = [];
    (async (e) => {

      entidadeSelected = selection.value != null ? selection.value : $('#id-select-Entidade [name="form-field-name"]').val();

      const data = {"IDEntidade": selection}
      const EtiquetasSeguranca = await services.apiCall.requestApi(
          "/Fiscalizacao/GetSelosSegurancaEntidade",
          data,
          "get"
      );

      console.log('EtiquetasCellSelos');

      if(EtiquetasSeguranca){
        EtiquetasSeguranca.map((Etiqueta, index) => (
          optionsSelos.push(<Option key={index} value={Etiqueta.idSelosSeguranca}>{Etiqueta.numeroSelo}</Option>)
        ));
      }

      //const data2 = {"IDEntidade": selection}
      const data2 = {"IDEntidade": 19702}
      const EtiquetasSeguranca2 = await services.apiCall.requestApi(
          "/Fiscalizacao/GetAllSelosSegurancaEntidade",
          data2,
          "get"
      );

      console.log('EtiquetasCellSelos');

      if(EtiquetasSeguranca2){
        EtiquetasSeguranca2.map((Etiqueta, index) => (
          optionsSelos2.push(<Option key={index} value={Etiqueta.idSelosSeguranca}>{Etiqueta.numeroSelo}</Option>)
        ));
      }
    })();
  };

  var dataItemOutro;

class SelectCellSelosSelagem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            optionsSelos: [], // Gerenciamento de opções via estado
            mappedValues: {}, // Mapeamento de IDs para textos
        };

         // Definindo como propriedade da instância
    }
    componentDidMount() {
      thisSelect = this;
    }
    componentDidUpdate(prevProps, prevState) {
      if (prevState.optionsSelos !== this.state.optionsSelos) {
          console.log("Updated optionsSelos:", this.state.optionsSelos);
      }
      if (prevProps.dataItem !== this.props.dataItem) {
          console.log("Updated dataItem:", this.props.dataItem);
      }
  }
    static changeValueFromSelect = async (selection) => {
        myFunction(selection)
        
    };


    static getAllSelos = async (selection) => {
      const entidadeSelected = selection

        const data = { IDEntidade: 19702 };
        const EtiquetasSeguranca = await services.apiCall.requestApi(
            "/Fiscalizacao/GetSelosSegurancaEntidade",
            data,
            "get"
        );

        if (EtiquetasSeguranca) {
          optionAllSelos = EtiquetasSeguranca.map((Etiqueta, index) => ({
            value: Etiqueta.idSelosSeguranca,
            label: Etiqueta.numeroSelo,
          }));
          const newOptions = EtiquetasSeguranca.map((Etiqueta, index) => ({
              value: Etiqueta.idSelosSeguranca,
              label: Etiqueta.numeroSelo,
          }));

          this.setState({
              optionsSelos: newOptions,
              mappedValues: Object.fromEntries(newOptions.map(opt => [opt.value, opt.label])),
          });
        }
    }

    static changeValueFromSelectNumeroVasilha = async (e) => {
        optionAllSelos = [];
        const entidadeSelected = $("#instal_vinica_auto :selected").val().split("!")[1]

        const data = { IDEntidade: entidadeSelected };
        const EtiquetasSeguranca = await services.apiCall.requestApi(
            "/Fiscalizacao/GetSelosSegurancaEntidade",
            data,
            "get"
        );

        if (EtiquetasSeguranca) {
            optionAllSelos = EtiquetasSeguranca.map((Etiqueta, index) => ({
              value: Etiqueta.idSelosSeguranca,
              label: Etiqueta.numeroSelo,
            }));
            const newOptions = EtiquetasSeguranca.map((Etiqueta, index) => ({
                value: Etiqueta.idSelosSeguranca,
                label: Etiqueta.numeroSelo,
            }));

            thisSelect.setState({
                optionsSelos: newOptions
            });
        }
        if (e !== undefined) {
            const idVas = e.value.value ? e.value.value : e.value;
            const data = { IDVasilha: idVas };
            const EtiquetasSeguranca = await services.apiCall.requestApi(
                "Fiscalizacao/GetSelosEtiquetasVasilha",
                data,
                "get"
            );

            if (EtiquetasSeguranca.selosSeguranca.length > 0) {
              optionAllSelos = optionAllSelos.concat(
                EtiquetasSeguranca.selosSeguranca.map((etiqueta, index) => ({
                    value: etiqueta.idSelo,
                    label: etiqueta.selo,
                }))
              );

                const newOptions = optionAllSelos.map((etiqueta, index) => ({
                    value: etiqueta.value,
                    label: etiqueta.label,
                }));

                const selectedValues = EtiquetasSeguranca.selosSeguranca.map(etiqueta => etiqueta.idSelo);

                thisSelect.setState({
                    optionsSelos: newOptions,
                    mappedValues: Object.fromEntries(newOptions.map(opt => [opt.value, opt.label])),
                });
                if($("#tipo_auto :selected").val() != "15"){
                    thisSelect.handleChangeCertProcSelosSeg(selectedValues);
                }
                
            }else{
              optionAllSelos = [];
              const entidadeSelected = $("#instal_vinica_auto :selected").val().split("!")[1]

              //const data = { IDEntidade: entidadeSelected };
              const data = { IDEntidade: 19702 };
              const EtiquetasSeguranca = await services.apiCall.requestApi(
                  "/Fiscalizacao/GetSelosSegurancaEntidade",
                  data,
                  "get"
              );

              if (EtiquetasSeguranca) {
                  optionAllSelos = EtiquetasSeguranca.map((Etiqueta, index) => ({
                    value: Etiqueta.idSelosSeguranca,
                    label: Etiqueta.numeroSelo,
                  }));
                  const newOptions = EtiquetasSeguranca.map((Etiqueta, index) => ({
                      value: Etiqueta.idSelosSeguranca,
                      label: Etiqueta.numeroSelo,
                  }));


                  thisSelect.setState({
                      optionsSelos: newOptions,
                      mappedValues: Object.fromEntries(newOptions.map(opt => [opt.value, opt.label])),
                  });

                  const selectedValues = [];

                  thisSelect.handleChangeCertProcSelosSeg(selectedValues);
              }
            }
        }
    };

    handleChangeCertProcSelosSeg = (selectedValues) => {
        const { mappedValues } = this.state;
        if(dataItemOutro){
            this.props.onChange({
                dataItem: dataItemOutro.dataItem,
                field: this.props.field,
                syntheticEvent: null,
                value:selectedValues.map(value => ({
                    value,
                    label: mappedValues[value] || value,
                })),
            });
        }else if(!this.props.dataItem.ProductID){
            this.props.onChange({
                dataItem: this.props.dataItem,
                field: this.props.field,
                syntheticEvent: null,
                value:selectedValues.map(value => ({
                    value,
                    label: mappedValues[value] || value,
                })),
            });
        }else{
            this.props.onChange({
                dataItem: this.props.dataItem,
                field: this.props.field,
                syntheticEvent: null,
                value:selectedValues.map(value => ({
                    value,
                    label: mappedValues[value] || value,
                })),
            });
        }
        
    };

   

    render() {
      const { optionsSelos, mappedValues } = this.state;
      const { dataItem } = this.props;
      const field = this.props.field || '';
      dateValueItem = dataItem
      // Certifique-se de que dataValue é uma lista de valores (não objetos)
      const dataValue = (dataItem[field] || []).map((value) =>
          typeof value === 'object' ? value.value : value
      );
  
    //   if (this.props.dataItem.inEdit == true) {
    //       dataItemOutro = this.props;
    //   }
  
      return (
          <td>
              {this.props.dataItem.inEdit ? (
                  <Select
                      mode="multiple"
                      allowClear
                      placeholder="Selecione as Etiquetas de segurança"
                      value={dataValue} // Garantido como lista de strings/números
                      onChange={this.handleChangeCertProcSelosSeg}
                      style={{ width: "100%" }}
                  >
                      {optionsSelos.map((option) => (
                          <Option key={option.value} value={option.value}>
                              {option.label}
                          </Option>
                      ))}
                  </Select>
              ) : dataValue && dataValue.length > 0 ? (
                  dataValue.map((value, index) => (
                      <span key={index} className="ant-select-selection-item-content-etiquetas">
                          {mappedValues[value] || optionsSelos.length > 0 ? optionsSelos.find(c=> c.value == value) ? optionsSelos.find(c=> c.value == value).label : value : value}
                      </span>
                  ))
              ) : null}
          </td>
      );
  }
}
export default SelectCellSelosSelagem;